import Drawer, { DrawerProps } from '@mui/material/Drawer';

type AppDrawerProps = Omit<DrawerProps, 'onClose'>;

const AppDrawer = ({ children, anchor = 'right', variant = 'temporary', ...props }: AppDrawerProps) => {
  const preventCloseOnEscapeKey = () => true;

  return (
    <Drawer anchor={anchor} variant={variant} onClose={() => preventCloseOnEscapeKey()} {...props}>
      {children}
    </Drawer>
  );
};

export default AppDrawer;
